<script setup lang="ts">
    import type { AiMessage } from '~/stores/aiAssistantTypes';
    import { ENTITY_LABEL_KEY_MAP } from '~/utils/aiEntityMeta';

    const props = defineProps<{
        message: AiMessage;
    }>();

    const { t } = useTranslation();

    const documentsCreated = computed(() => props.message.documentCreated ?? []);
    const hasDocs = computed(() => documentsCreated.value.length > 0);

    const getArtifactTitle = (doc: { type: string; id: string }) =>
        t(ENTITY_LABEL_KEY_MAP[doc.type] ?? 'ai.entity.document');
</script>

<template>
    <div class="flex flex-col items-start gap-[8px] py-1">
        <!-- Narration text — yellow dashed pill -->
        <div
            class="inline-flex items-center gap-2 px-[14px] py-[8px] rounded-md font-inter text-[12px] text-gray-600"
            style="background: rgba(255, 196, 0, 0.08); border: 1px dashed rgba(255, 196, 0, 0.5);"
        >
            <i class="fa-solid fa-wand-magic-sparkles text-[11px] text-[#E8B102]" />
            <span>{{ message.content }}</span>
        </div>

        <!-- Artifact card(s) — white assistant bubble. -->
        <div
            v-if="hasDocs"
            class="bg-white border border-[#E7E7E7] rounded-[12px] rounded-bl-[4px] px-4 py-3 shadow-[0_1px_2px_rgba(0,0,0,0.03)] flex flex-col gap-[10px]"
        >
            <p
                v-if="message.bubbleIntro"
                class="font-inter text-[13px] leading-[1.5] text-gray-900 m-0"
            >
                {{ message.bubbleIntro }}
            </p>
            <AiArtifactCard
                v-for="doc in documentsCreated"
                :key="`${doc.type}-${doc.id}`"
                :type="doc.type"
                :id="doc.id"
                :title="getArtifactTitle(doc)"
            />
        </div>
    </div>
</template>
